// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`renders correctly with props 1`] = `
<div
  className="sidebar"
>
  <div
    className="sidebar-header"
  >
    <h2>
      Move User To Account
    </h2>
    <button
      className="close"
      data-testid="close-move-section"
      onClick={[Function]}
      type="button"
    >
      <svg
        fill="currentColor"
        height="1em"
        stroke="currentColor"
        strokeWidth="0"
        style={
          Object {
            "color": undefined,
          }
        }
        viewBox="0 0 24 24"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3,3 L21,21 M3,21 L21,3"
          fill="none"
          stroke="#000"
          strokeWidth="2"
        />
      </svg>
    </button>
  </div>
  <div
    className="sidebar-body"
  >
    <div
      className="form-group"
    >
      <label>
        Account
      </label>
      <div
        className=" css-2b097c-container"
        onKeyDown={[Function]}
      >
        <div
          className=" css-ry7o3u-control"
          onMouseDown={[Function]}
          onTouchEnd={[Function]}
        >
          <div
            className=" css-g1d714-ValueContainer"
          >
            <div
              className=" css-1uccc91-singleValue"
            >
              None
            </div>
            <div
              className="css-b8ldur-Input"
            >
              <div
                className=""
                style={
                  Object {
                    "display": "inline-block",
                  }
                }
              >
                <input
                  aria-autocomplete="list"
                  autoCapitalize="none"
                  autoComplete="off"
                  autoCorrect="off"
                  disabled={false}
                  id="react-select-2-input"
                  onBlur={[Function]}
                  onChange={[Function]}
                  onFocus={[Function]}
                  spellCheck="false"
                  style={
                    Object {
                      "background": 0,
                      "border": 0,
                      "boxSizing": "content-box",
                      "color": "inherit",
                      "fontSize": "inherit",
                      "label": "input",
                      "opacity": 1,
                      "outline": 0,
                      "padding": 0,
                      "width": "1px",
                    }
                  }
                  tabIndex="0"
                  type="text"
                  value=""
                />
                <div
                  style={
                    Object {
                      "height": 0,
                      "left": 0,
                      "overflow": "scroll",
                      "position": "absolute",
                      "top": 0,
                      "visibility": "hidden",
                      "whiteSpace": "pre",
                    }
                  }
                >
                  
                </div>
              </div>
            </div>
          </div>
          <div
            className=" css-1hb7zxy-IndicatorsContainer"
          >
            <span
              className=" css-1xjgjl1-IndicatorSeparator"
            />
            <div
              aria-hidden="true"
              className=" css-tlfecz-indicatorContainer"
              onMouseDown={[Function]}
              onTouchEnd={[Function]}
            >
              <svg
                aria-hidden="true"
                className="css-6q0nyr-Svg"
                focusable="false"
                height={20}
                viewBox="0 0 20 20"
                width={20}
              >
                <path
                  d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      className="form-group"
    >
      <label>
        Subscription
      </label>
      <div
        className=" css-2b097c-container"
        onKeyDown={[Function]}
      >
        <div
          className=" css-ry7o3u-control"
          onMouseDown={[Function]}
          onTouchEnd={[Function]}
        >
          <div
            className=" css-g1d714-ValueContainer"
          >
            <div
              className=" css-1uccc91-singleValue"
            >
              None
            </div>
            <input
              aria-autocomplete="list"
              className="css-62g3xt-dummyInput"
              disabled={false}
              id="react-select-3-input"
              onBlur={[Function]}
              onChange={[Function]}
              onFocus={[Function]}
              readOnly={true}
              tabIndex="0"
              value=""
            />
          </div>
          <div
            className=" css-1hb7zxy-IndicatorsContainer"
          >
            <span
              className=" css-1xjgjl1-IndicatorSeparator"
            />
            <div
              aria-hidden="true"
              className=" css-tlfecz-indicatorContainer"
              onMouseDown={[Function]}
              onTouchEnd={[Function]}
            >
              <svg
                aria-hidden="true"
                className="css-6q0nyr-Svg"
                focusable="false"
                height={20}
                viewBox="0 0 20 20"
                width={20}
              >
                <path
                  d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      className="form-group"
    >
      <label>
        Academy Subscription
      </label>
      <div
        className=" css-2b097c-container"
        onKeyDown={[Function]}
      >
        <div
          className=" css-ry7o3u-control"
          onMouseDown={[Function]}
          onTouchEnd={[Function]}
        >
          <div
            className=" css-g1d714-ValueContainer"
          >
            <div
              className=" css-1uccc91-singleValue"
            >
              None
            </div>
            <input
              aria-autocomplete="list"
              className="css-62g3xt-dummyInput"
              disabled={false}
              id="react-select-4-input"
              onBlur={[Function]}
              onChange={[Function]}
              onFocus={[Function]}
              readOnly={true}
              tabIndex="0"
              value=""
            />
          </div>
          <div
            className=" css-1hb7zxy-IndicatorsContainer"
          >
            <span
              className=" css-1xjgjl1-IndicatorSeparator"
            />
            <div
              aria-hidden="true"
              className=" css-tlfecz-indicatorContainer"
              onMouseDown={[Function]}
              onTouchEnd={[Function]}
            >
              <svg
                aria-hidden="true"
                className="css-6q0nyr-Svg"
                focusable="false"
                height={20}
                viewBox="0 0 20 20"
                width={20}
              >
                <path
                  d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      className="button"
      disabled={false}
      onClick={[Function]}
      type="button"
    >
      Update
    </button>
  </div>
</div>
`;

exports[`renders correctly without props 1`] = `
<div
  className="sidebar"
>
  <div
    className="sidebar-header"
  >
    <h2>
      Move User To Account
    </h2>
    <button
      className="close"
      data-testid="close-move-section"
      type="button"
    >
      <svg
        fill="currentColor"
        height="1em"
        stroke="currentColor"
        strokeWidth="0"
        style={
          Object {
            "color": undefined,
          }
        }
        viewBox="0 0 24 24"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3,3 L21,21 M3,21 L21,3"
          fill="none"
          stroke="#000"
          strokeWidth="2"
        />
      </svg>
    </button>
  </div>
  <div
    className="sidebar-body"
  >
    <div
      className="form-group"
    >
      <label>
        Account
      </label>
      <div
        className=" css-2b097c-container"
        onKeyDown={[Function]}
      >
        <div
          className=" css-ry7o3u-control"
          onMouseDown={[Function]}
          onTouchEnd={[Function]}
        >
          <div
            className=" css-g1d714-ValueContainer"
          >
            <div
              className=" css-1uccc91-singleValue"
            >
              None
            </div>
            <div
              className="css-b8ldur-Input"
            >
              <div
                className=""
                style={
                  Object {
                    "display": "inline-block",
                  }
                }
              >
                <input
                  aria-autocomplete="list"
                  autoCapitalize="none"
                  autoComplete="off"
                  autoCorrect="off"
                  disabled={false}
                  id="react-select-5-input"
                  onBlur={[Function]}
                  onChange={[Function]}
                  onFocus={[Function]}
                  spellCheck="false"
                  style={
                    Object {
                      "background": 0,
                      "border": 0,
                      "boxSizing": "content-box",
                      "color": "inherit",
                      "fontSize": "inherit",
                      "label": "input",
                      "opacity": 1,
                      "outline": 0,
                      "padding": 0,
                      "width": "1px",
                    }
                  }
                  tabIndex="0"
                  type="text"
                  value=""
                />
                <div
                  style={
                    Object {
                      "height": 0,
                      "left": 0,
                      "overflow": "scroll",
                      "position": "absolute",
                      "top": 0,
                      "visibility": "hidden",
                      "whiteSpace": "pre",
                    }
                  }
                >
                  
                </div>
              </div>
            </div>
          </div>
          <div
            className=" css-1hb7zxy-IndicatorsContainer"
          >
            <span
              className=" css-1xjgjl1-IndicatorSeparator"
            />
            <div
              aria-hidden="true"
              className=" css-tlfecz-indicatorContainer"
              onMouseDown={[Function]}
              onTouchEnd={[Function]}
            >
              <svg
                aria-hidden="true"
                className="css-6q0nyr-Svg"
                focusable="false"
                height={20}
                viewBox="0 0 20 20"
                width={20}
              >
                <path
                  d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      className="form-group"
    >
      <label>
        Subscription
      </label>
      <div
        className=" css-2b097c-container"
        onKeyDown={[Function]}
      >
        <div
          className=" css-ry7o3u-control"
          onMouseDown={[Function]}
          onTouchEnd={[Function]}
        >
          <div
            className=" css-g1d714-ValueContainer"
          >
            <div
              className=" css-1uccc91-singleValue"
            >
              None
            </div>
            <input
              aria-autocomplete="list"
              className="css-62g3xt-dummyInput"
              disabled={false}
              id="react-select-6-input"
              onBlur={[Function]}
              onChange={[Function]}
              onFocus={[Function]}
              readOnly={true}
              tabIndex="0"
              value=""
            />
          </div>
          <div
            className=" css-1hb7zxy-IndicatorsContainer"
          >
            <span
              className=" css-1xjgjl1-IndicatorSeparator"
            />
            <div
              aria-hidden="true"
              className=" css-tlfecz-indicatorContainer"
              onMouseDown={[Function]}
              onTouchEnd={[Function]}
            >
              <svg
                aria-hidden="true"
                className="css-6q0nyr-Svg"
                focusable="false"
                height={20}
                viewBox="0 0 20 20"
                width={20}
              >
                <path
                  d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      className="form-group"
    >
      <label>
        Academy Subscription
      </label>
      <div
        className=" css-2b097c-container"
        onKeyDown={[Function]}
      >
        <div
          className=" css-ry7o3u-control"
          onMouseDown={[Function]}
          onTouchEnd={[Function]}
        >
          <div
            className=" css-g1d714-ValueContainer"
          >
            <div
              className=" css-1uccc91-singleValue"
            >
              None
            </div>
            <input
              aria-autocomplete="list"
              className="css-62g3xt-dummyInput"
              disabled={false}
              id="react-select-7-input"
              onBlur={[Function]}
              onChange={[Function]}
              onFocus={[Function]}
              readOnly={true}
              tabIndex="0"
              value=""
            />
          </div>
          <div
            className=" css-1hb7zxy-IndicatorsContainer"
          >
            <span
              className=" css-1xjgjl1-IndicatorSeparator"
            />
            <div
              aria-hidden="true"
              className=" css-tlfecz-indicatorContainer"
              onMouseDown={[Function]}
              onTouchEnd={[Function]}
            >
              <svg
                aria-hidden="true"
                className="css-6q0nyr-Svg"
                focusable="false"
                height={20}
                viewBox="0 0 20 20"
                width={20}
              >
                <path
                  d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      className="button"
      disabled={false}
      onClick={[Function]}
      type="button"
    >
      Update
    </button>
  </div>
</div>
`;
